import Unile from '@/util'

const state = {
  count: 1,
  alredyCollect: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js